var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container is-centered"},[_c('spinner',{attrs:{"speed":1.0,"depth":5,"size":100,"color":'$brand-primary'}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }